import { loginPost, refreshPost, deleteOp, get, post, put } from '@/utils/request'

const login = (params) => loginPost('/api/auth/oauth2/token?grant_type=password&scope=server', params)
const logout = (params) => deleteOp('/api/auth/token/logout', params)
const checkToken = (params) => get('/api/auth/token/check_token', params)
const register = (params) => post('/api/admin/register/user', params)
const getAreaTree = (params) => get('/api/admin/sysArea/tree', params)
const getAbbreviation = (params) => get('/api/admin/sysArea/getAbbreviation', params)
const getMenu = (params) => get('/api/admin/menu', params)
const getInfo = (params) => get('/api/admin/user/info', params)
const updatePassword = (params) => put('/api/admin/user/personal/password', params)
const refreshToken = (params) => refreshPost('/auth/oauth2/token?grant_type=refresh_token', params)
const checkUnCode = (params) => get('/api/record/company/checkUnCode', params)
const codeCreate = (params) => get('/api/code/create', params)
const verifyRegisterCompany = (params) => post('/api/record/company/verifyRegisterCompany', params)
const getDictType = (params) => get(`/api/admin//dict/type/${params.type}`, params)

const sendEmail = (params) => post('/api/admin/user/email/code/send', params)
const checkEmail = (params) => post('/api/admin/user/email/code/check', params)

export {
    login,
    refreshToken,
    logout,
    checkToken,
    register,
    getAreaTree,
    getAbbreviation,
    getMenu,
    getInfo,
    updatePassword,
    checkUnCode,
    codeCreate,
    verifyRegisterCompany,
    getDictType,
    sendEmail,
    checkEmail
}